module.exports = __webpack_public_path__ + "static/ravi-49fd405c4dd2e0cecc49257a94177332.png";